module.exports = __webpack_public_path__ + "img/terre_off.22282ad6.gif";